import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import { getStep } from "./AIRoleBuilderTasksList";

/**
 * AIRoleBuilderTaskStage
 *
 * The stage an AI role builder request is at, shown alongside its progress.
 *
 * @param {Object}  task  The AI role builder request
 */
const AIRoleBuilderTaskStage = ({ task, ...props }) => (
  <span css={styles.stage} {...props}>
    {getStep(task)}
  </span>
);

const styles = {
  stage: css`
    font-size: ${fontSize.xsmall};
    color: ${colors.grayAnatomyLight1};
  `,
};

AIRoleBuilderTaskStage.propTypes = {
  task: PropTypes.object,
};

export default AIRoleBuilderTaskStage;
